import { cineamoApiClient } from '../../apiClient';
import { UrlQueryParameter, buildUrlQuery } from '../../helpers/url-query-helper';
import { ApiErrorResponse } from '../../types/ApiErrorResponse.types';
import { MovieTourStopListResponse } from '../../types/ApiListResponse.types';
import { ApiResponse } from '../../types/ApiResponse.types';

import { MovieTourStopDto, MovieTourStopInputDto } from './movie-tour-stop.types';

export type GetMovieTourStopsQueryParameter = UrlQueryParameter & {
    movieTourIds?: number[];
    cinemaIds?: number[];
    cityIds?: number[];
    showingIds?: number[];
    iso31661s?: string[];
    startDatetimeStart?: string;
    startDatetimeEnd?: string;
};

export async function getMovieTourStops(
    urlParams?: GetMovieTourStopsQueryParameter
): Promise<ApiResponse<MovieTourStopListResponse> | null> {
    return cineamoApiClient
        .get<ApiResponse<MovieTourStopListResponse>>(`/movie-tour-stops${buildUrlQuery(urlParams)}`, {
            credentials: 'same-origin'
        })
        .then((response) => response.data)
        .catch(() => {
            return null;
        });
}

export async function getMovieTourStopById(
    movieTourStopId: number | string,
    urlParams?: UrlQueryParameter
): Promise<ApiResponse<MovieTourStopDto> | null> {
    return cineamoApiClient
        .get<ApiResponse<MovieTourStopDto>>(`/movie-tour-stops/${movieTourStopId}${buildUrlQuery(urlParams)}`, {
            credentials: 'same-origin'
        })
        .then((response) => response.data)
        .catch(() => {
            return null;
        });
}

export async function createMovieTourStop(
    movieTourStopInput: MovieTourStopInputDto
): Promise<ApiResponse<MovieTourStopDto> | ApiErrorResponse<MovieTourStopInputDto>> {
    return cineamoApiClient
        .post<ApiResponse<MovieTourStopDto>>('/movie-tour-stops', movieTourStopInput, {
            credentials: 'same-origin'
        })
        .then((response) => response.data)
        .catch((error) => error);
}

export async function updateMovieTourStop(
    movieTourStopId: number,
    movieTourStopInput: Partial<MovieTourStopInputDto>
): Promise<ApiResponse<MovieTourStopDto> | ApiErrorResponse<Partial<MovieTourStopInputDto>>> {
    return cineamoApiClient
        .patch<ApiResponse<MovieTourStopDto>>(`/movie-tour-stops/${movieTourStopId}`, movieTourStopInput, {
            credentials: 'same-origin'
        })
        .then((response) => response.data)
        .catch((error) => error);
}

export async function deleteMovieTourStop(movieTourStopId: number): Promise<boolean> {
    return cineamoApiClient
        .delete(`/movie-tour-stops/${movieTourStopId}`, {
            credentials: 'same-origin'
        })
        .then(() => true)
        .catch(() => false);
}
